module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/star3.0a0ec00e.png";